import React, { useContext, useMemo } from 'react';
import { getLocale, useIntl } from 'umi';
import { Bubble, Button } from 'tea-component';
import { RefreshContext } from '../PageContainer/context';
import SvgIcon from '@/pages/home/components/SvgIcon';

interface Iprops {
  className?:string;
  style?:React.CSSProperties;
  config?:any;
}

const RefreshBtn = (props:Iprops) => {
  const { style,className, config } = props;
  const {contentEn ='', contentCn='', } = config || {};
  const { forceRefresh, dispatchRefresh } = useContext(RefreshContext);
  const { formatMessage } = useIntl();
  const isEn = getLocale() === 'en-US';
  const refreshStart = () => {
    dispatchRefresh(true);
  };

  const content = useMemo(()=>(isEn ? contentEn : contentCn) || formatMessage({ id: "component_refresh_tips" }),[isEn]);

  return <Bubble
    dark
    placement="left"
    content={content}
    style={{ maxWidth: '350px' }}
  >
    {
      (<Button
        style={style}
        className={`ns-btn--border btn-top ${className ? className : ''}`}
        loading={forceRefresh}
        onClick={refreshStart}
      >
        {!forceRefresh && <SvgIcon style={{marginRight: "6px"}}className='btn-top-icon' type="refresh" />}
        {formatMessage({ id: "component_refresh_btn_name" })}
      </Button>
      )
    }
  </Bubble>;
};

export default RefreshBtn;
